import { useState } from "react"
import { HEROES } from "@/data/heroes"
import { HERO_ICONS } from "@/data/heroIcons"

export function AvatarStep({ onNext }) {
  const [selectedId, setSelectedId] = useState(null)
  const selected = HEROES.find((h) => h.id === selectedId)

  return (
    <div className="space-y-5">
      <div className="text-center space-y-1">
        <h2 className="text-2xl font-black text-slate-900">Choose your hero</h2>
        <p className="text-sm text-slate-500">
          Your hero will guide you throughout EarlyScape. Who do you identify with?
        </p>
      </div>

      {/* Hero grid */}
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2 max-h-72 overflow-y-auto pr-1">
        {HEROES.map((hero) => {
          const isSelected = selectedId === hero.id
          const icon = HERO_ICONS[hero.id]

          return (
            <button
              key={hero.id}
              onClick={() => setSelectedId(hero.id)}
              className={`flex flex-col items-center gap-1.5 p-2.5 rounded-2xl border-2 transition-all text-left ${
                isSelected
                  ? "border-indigo-500 bg-indigo-50 shadow-md shadow-indigo-100"
                  : "border-slate-100 bg-white hover:border-slate-200"
              }`}
            >
              {/* Hero icon */}
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center shrink-0 p-2 shadow-sm"
                style={{ backgroundColor: hero.color }}
              >
                {icon ?? (
                  <span className="text-white font-black text-base">
                    {hero.name.charAt(0)}
                  </span>
                )}
              </div>

              <p className="text-[11px] font-bold text-slate-800 text-center leading-tight line-clamp-1 w-full">
                {hero.name}
              </p>
              <p className="text-[10px] text-slate-400 text-center leading-tight line-clamp-1 w-full">
                {hero.tagline}
              </p>

              {/* Trait chips */}
              <div className="flex flex-wrap gap-0.5 justify-center">
                {hero.traits.slice(0, 2).map((t) => (
                  <span
                    key={t}
                    className="text-[9px] bg-slate-100 text-slate-500 px-1.5 py-0.5 rounded-full font-medium"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </button>
          )
        })}
      </div>

      {/* Hero selection message */}
      {selected && (
        <div
          className="rounded-2xl p-4 border-l-4 text-sm font-medium leading-relaxed"
          style={{ borderColor: selected.color, backgroundColor: `${selected.color}18` }}
        >
          <div className="flex items-center gap-2 mb-1.5">
            <div
              className="w-7 h-7 rounded-lg flex items-center justify-center p-1 shrink-0"
              style={{ backgroundColor: selected.color }}
            >
              {HERO_ICONS[selected.id] ?? (
                <span className="text-white font-black text-xs">{selected.name.charAt(0)}</span>
              )}
            </div>
            <p
              className="text-xs font-bold uppercase tracking-wide"
              style={{ color: selected.color }}
            >
              {selected.name} says:
            </p>
          </div>
          <p className="text-slate-700 italic">&ldquo;{selected.selectionMessage}&rdquo;</p>
        </div>
      )}

      <button
        disabled={!selectedId}
        onClick={() => onNext({ avatar: selectedId })}
        className="w-full bg-indigo-600 hover:bg-indigo-700 disabled:opacity-40 text-white font-bold py-3 rounded-xl text-sm transition-all active:scale-95"
      >
        {selectedId ? `Choose ${selected?.name}` : "Select a hero to continue"}
      </button>
    </div>
  )
}
